const chartoptions = {
  /**
   * 树状图
   * 适用表格：产业图谱
   */
   tree_map(data) {
    let num_name
    return {
      tooltip: {
        trigger: 'item',
        backgroundColor: '#404040',
        padding: 12,
        formatter: (params) => {
          let htm = ''
          if(params.data.showSize > 0) {
            htm = `<div class="tip-item">
                    <span class="spa2">≈` + params.data.showSize + `百万美元</span>
                  </div>`
          }
          return `<div class="tool-tip"><div class="tool-head">` + params.name + `</div>` + htm + `</div>`
        }
      },
      series: [{
        name: 'prev',
        type: 'treemap',
        width: '100%',
        height: '100%',
        roam: false,
        leafDepth: 3,
        drillDownIcon: '',
        nodeClick: true,
        breadcrumb: {
          show: false
        },
        label: {
          padding: [6, 0, 0, 6],
          color: '#000',
          show: true,
          position: 'insideTopLeft',
          fontSize: 11,
          lineHeight: 18,
          formatter: (params) => {
            return params.name + '\n约' + params.data.showSize
          }
        },
        upperLabel: {
          padding: [0, 0, 0, 10],
          show: true,
          // formatter: (params) => {
          //   return params.name + '\t\t\t' + getNum(params.value[1]) 
          // },
          height: 30,
          lineHeight: 30
        },
        levels: [{
          itemStyle: {
            borderWidth: 0,
            gapWidth: 1
          },
          upperLabel: {
            show: false
          }
        }, {
          itemStyle: {
            borderWidth: 0,
            gapWidth: 1
          }
        }, {
          itemStyle: {
            borderWidth: 0,
            gapWidth: 1
          }
        }],
        data: data
      }]
    }
  }
}

export default chartoptions